import GameConfig from './GameConfig';
import GameModel from './GameModel';
import {Loc} from 'src/common/map/Location';
import GameUtils from './GameUtils';
import {MapState} from 'src/common/map/MapState';
import {Sprite} from 'pixi.js';
import {buildingTintForPlayerIndex} from 'src/Pixi/player-colors';
import * as PIXI from 'pixi.js';

export class CannonCursor {
    private tile: Loc;
    private cannon: Sprite;
    public canPlace: boolean;
    private remainingCount: PIXI.Text;

    public constructor() {
        this.createSprite();
    }

    public updatePosition(loc: Loc, map: MapState, playerIndex: number): void {
        this.tile = loc;
        this.show();
        const pos = this.spritePosition();
        this.cannon.position.set(pos.x, pos.y);
        this.canPlace = map.canPlayerPlaceCannon(playerIndex, this.tile.x, this.tile.y);
        this.cannon.tint = this.canPlace ? buildingTintForPlayerIndex(playerIndex) : 0xff0000;
    }

    public updateRemainingCount(remainingCount: number): void {
        this.remainingCount.text = '' + remainingCount;
    }

    public hide(): void {
        GameModel.cursorContainer.removeChild(this.cannon);
    }

    private createSprite(): void {
        const texture = GameUtils.spriteTexture('cannons/cannon');
        this.cannon = new PIXI.Sprite(texture);
        const style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24,
            fill: 0xffffff,
        });
        this.remainingCount = new PIXI.Text('', style);
        this.remainingCount.anchor.set(0.5, 0.5);
        this.remainingCount.position.set(GameConfig.tileSize, GameConfig.tileSize);
        this.cannon.addChild(this.remainingCount);
    }

    private show(): void {
        GameModel.cursorContainer.addChild(this.cannon);
    }

    private spritePosition(): Loc {
        return {x: this.tile.x * GameConfig.tileSize, y: this.tile.y * GameConfig.tileSize};
    }
}



// WEBPACK FOOTER //
// ./src/game/CannonCursor.ts